import { Unity, useUnityContext } from "react-unity-webgl";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import heartDecor from "../../../assets/images/coin-store-figma/decor-heart.svg";
import "./GameDetail.css";

export default function ThisOrThat() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const chat_id = searchParams.get("chat_id") ?? location.state?.chat_id ?? null;
    const user_id = searchParams.get("user_id") ?? location.state?.user_id ?? null;

    console.log("ThisOrThat params:", { chat_id, user_id });

    const { unityProvider } = useUnityContext({
        loaderUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/ThisOrThat/WebGLThisOrThat.loader.js`,
        dataUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/ThisOrThat/WebGLThisOrThat.data`,
        frameworkUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/ThisOrThat/WebGLThisOrThat.framework.js`,
        codeUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/ThisOrThat/WebGLThisOrThat.wasm`,
    });

    return (
        <section className="game-detail-page">
            <img src={heartDecor} alt="" className="game-detail-heart" aria-hidden="true" />
            <div className="game-detail-hero">
                <Container className="game-detail-hero-inner">
                    <button className="game-detail-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
                        <FaArrowLeftLong />
                    </button>
                    <h1 className="game-detail-title">This Or That</h1>
                </Container>
            </div>
            <div className="game-detail-main py-sm-5 py-4">
                <Container className="game-detail-container">
                    <div className="game-detail-frame game-detail-frame-tot">
                        <Unity unityProvider={unityProvider} className="game-detail-unity game-detail-unity-tot" />
                    </div>
                </Container>
            </div>
        </section>
    );
}
